import animate from "./animate/animate.js";

export default {};
